import React from 'react'
import { Carousel } from 'react-bootstrap'
import DynamicForm from './DynamicForm'
const DynamicForms = (props) => {
   const {
      currentStepIndex,
      listData,
      scrollOnError = true,
      formState,
      setFormState,
      onSlid,
      validateCurrentOptionForm,
      basketState,
      setBasketState,
      setOpen,
      closeOnSelect = false,
      modelLoaded
   } = props

   const handleValidateForm = () => {
      const valid = validateCurrentOptionForm(scrollOnError)
      if (valid && closeOnSelect) {
         setOpen(false)
      }
   }

   const renderForms = () => {
      const forms = Object.values(listData).map((step, idx) => {
         const controls = step?.forms?.controls
         return (
            <Carousel.Item key={step.name} className='bg-white'>
               <DynamicForm
                  step={step}
                  basketState={basketState}
                  setBasketState={setBasketState}
                  controls={controls}
                  formState={formState}
                  setFormState={setFormState}
                  className='optionsForm'
                  id={`optionsForm_${idx}`}
                  noValidate
                  isValid={listData[idx].isValid}
                  validated={listData[idx].wasValidated}
                  validateForm={handleValidateForm}
                  activeIndex={currentStepIndex}
                  listData={listData}
                  modelLoaded={modelLoaded}
               />
            </Carousel.Item>
         )
      })

      return forms
   }
   return (
      <Carousel
         id={scrollOnError ? 'modalTop' : ''}
         activeIndex={currentStepIndex}
         variant="dark"
         className='h-100'
         interval={null}
         wrap={false}
         indicators={false}
         controls={false}
         onSlid={onSlid}
         fade={true}
      >
         {renderForms()}
      </Carousel>
   )
}
export default DynamicForms